











































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import EventTree from '@/views/error-monitor/error-monitor-event-tree.component.vue';
import EventError from '@/domain/event/event-error.entity';
import EventService from '@/domain/event/event.service';
import Event from '@/domain/event/event.entity';

@Component({
  components: {
    EventTree,
  },
})
export default class EventsList extends Vue {
  @Prop() details!: EventError[];

  @Prop() checked!: Boolean;

  private eventService = new EventService();

  private event: Event[] = [];

  private iconMap: Map<string, string> = new Map();

  constructor() {
    super();
    this.iconMap.set('PENDING', 'cancel');
    this.iconMap.set('REPROCESSED', 'refresh');
  }

  get detailsSorted() {
    if (this.details) {
      return this.details
        .sort((baseItem, comparedItem) => (baseItem.eventDate > comparedItem.eventDate ? -1 : 1));
    }
    return [];
  }

  getIcon(status: string) {
    return this.iconMap.get(status);
  }

  fetchEventList(error: EventError) {
    this.eventService
      .searchAllEvents(error.eventId)
      .then(event => (this.event = [event]));
  }

  showContext(context: string, date: Date) {
    this.$emit('showContext', context, date);
  }
}
